import { CSSObject } from "@emotion/react";
import { AssignModalZIndex } from "@/view/AssignModal/AssignModal.style";

export const modalCss = {
  zIndex: AssignModalZIndex,
};

export const modalContentWrapperCss: CSSObject = {
  "&": {
    width: "800px",
    height: "auto",
    maxHeight: "85vh",
    maxWidth: "unset",
  },
};

export const modalFooterCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "end",
  alignItems: "center",
  minHeight: "unset",
};

export const editFormFooterButtonsWrapperCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
};
